import client from './axios';

let studentStatusesCache = null;

export const enumApi = {
  getFeeFrequencies: async () => {
    const response = await client.get('/enums/fee-frequencies');
    return response.data;
  },

  getFeeCategories: async () => {
    const response = await client.get('/enums/fee-categories');
    return response.data;
  },

  getStudentStatuses: async () => {
    if (studentStatusesCache) {
      return studentStatusesCache;
    }
    const response = await client.get('/enums/student-statuses');
    studentStatusesCache = response.data;
    return response.data;
  }
};
